module.exports = __webpack_public_path__ + "static/media/GRC.4198b260.svg";